"use strict";

import Page from "./TicketTransfer.jsx";

export const auth = true;
export const title = "i18n:ticketTransfer.pageTitle";
export const Component = Page;
